import React from 'react';

const LoadingSpinner = React.forwardRef((props, ref) => (
  <div className="o-loading-spinner" ref={ref}>
    <div className="o-loading-spinner__element"></div>
  </div>
));

export default LoadingSpinner;
